import Repository from '../repository';

const resource = '/cart';

export default {
  get(params) {
    return Repository.get(`${resource}`, { params });
  },
  store(cart) {
    return Repository.post(`${resource}`, cart);
  },
  update(cart) {
    return Repository.post(`${resource}/${cart.id}`, { item: cart.item, user: cart.user, type: cart.type });
  },
  remove(cartId, cartItemId) {
    return Repository.delete(`${resource}/${cartId}/${cartItemId}`);
  },
  apply_coupon(cartId, couponCode) {
    return Repository.post(`${resource}/${cartId}/apply_coupon`, { coupon_code: couponCode });
  },
};
